import { MouseEvent } from 'react';
import { Tooltip } from '@material-ui/core';
import ShareOutlinedIcon from '@material-ui/icons/ShareOutlined';

interface SharedIndicatorProps {
  /** Override hover text (e.g. incoming "Shared with you"). */
  title?: string;
  /** Owner-side org count from GET /share/owned. */
  organizationCount?: number;
  /** Owner-side: open Share modal (stops row click). */
  onClick?: (event: MouseEvent) => void;
}

export const formatSharedOutTitle = (organizationCount?: number): string => {
  if (organizationCount == null || organizationCount < 1) {
    return 'Shared with other organizations';
  }
  return `Shared with ${organizationCount} organization${
    organizationCount === 1 ? '' : 's'
  }`;
};

/** Compact sidebar cue that a resource is shared (replaces "(shared)" text). */
export default function SharedIndicator({
  title,
  organizationCount,
  onClick,
}: SharedIndicatorProps) {
  const resolvedTitle = title ?? formatSharedOutTitle(organizationCount);

  const handleClick = (event: MouseEvent) => {
    if (!onClick) return;
    event.stopPropagation();
    event.preventDefault();
    onClick(event);
  };

  return (
    <Tooltip title={resolvedTitle} placement='top'>
      <ShareOutlinedIcon
        htmlColor='#757575'
        onClick={handleClick}
        style={{
          fontSize: 14,
          flexShrink: 0,
          verticalAlign: 'middle',
          cursor: onClick ? 'pointer' : 'default',
        }}
        aria-label={resolvedTitle}
      />
    </Tooltip>
  );
}
